import {useCallback, useMemo, useState} from 'react';
import type {RowSelectionModel} from 'components/dataTable/types';
import {useLocalization} from 'localization';
import type {EditorMode} from '../../types';
import type {AgentSelection} from '../types';

const ALTERNATIVE_SELECTION = 'ALTERNATIVE_SELECTION';

export const useAgentSearchSelection = (mode: EditorMode): AgentSelection => {
  const {t} = useLocalization();
  const [selection, setSelection] = useState<RowSelectionModel>({
    type: 'include',
    ids: new Set(),
  });

  const handleSetAlternativeSelection = useCallback((selected: boolean) => {
    if (selected) {
      setSelection({
        type: 'include',
        ids: new Set([ALTERNATIVE_SELECTION]),
      });
    } else {
      setSelection({
        type: 'include',
        ids: new Set(),
      });
    }
  }, []);

  return useMemo(
    () => ({
      resultSelection: selection,
      alternativeSelection: selection.ids.has(ALTERNATIVE_SELECTION),
      alternativeLabel: t(`wizard.agent.step.1.alternative.${mode}.label`),
      setAlternativeSelection: handleSetAlternativeSelection,
      setResultSelection: setSelection,
    }),
    [handleSetAlternativeSelection, mode, selection, t],
  );
};
